import { Collection } from '@features/Collection';
import { getBookmarkedCollections } from '@pages/Home/constants/avenueConfigs';
import { HeartFilledIcon, HeartIcon } from '@radix-ui/react-icons';
import { IconButton, IconProps } from '@radix-ui/themes';
import React, { ForwardRefExoticComponent, RefAttributes } from 'react';

type Bookmark = 'true' | 'false';

const ICON_FOR_BOOKMARK: {
    [key in Bookmark]: ForwardRefExoticComponent<
        IconProps & RefAttributes<SVGSVGElement>
    >;
} = {
    true: HeartFilledIcon,
    false: HeartIcon,
};

interface BookmarkSwitchProps {
    onChange?: (isBookmarked: boolean) => void;
    collection: Collection;
}

export const BookmarkSwitch = ({
    onChange,
    collection,
}: BookmarkSwitchProps) => {
    const [isBookmarked, setIsBookmarked] = React.useState(false);
    const bookmarked = getBookmarkedCollections().includes(
        collection.proscopeId,
    );
    const Icon =
        ICON_FOR_BOOKMARK[String(isBookmarked || bookmarked) as Bookmark];

    const handleOnClick = (event: React.MouseEvent<SVGSVGElement>) => {
        event.stopPropagation();
        setIsBookmarked((old) => !old);
        onChange?.(!isBookmarked);
    };

    return (
        <IconButton
            variant='ghost'
            style={{ cursor: 'pointer' }}
            radius='full'
            asChild
        >
            <Icon onClick={handleOnClick} width={'24'} height={'24'} />
        </IconButton>
    );
};
